<div class="task-basic-preview-data">
  <div class="d-flex flex-column">
    <div
      *ngIf="!!service.task?.parent?.description"
      class="pointer parent-link"
      (click)="openParentPreview(service.task?.parent)"
    >
      <svg-icon [src]="'/assets/img/arrow-left-blue.svg'" />
      <span [title]="service.task?.parent?.description">
        {{ service.task?.parent?.description }}
      </span>
    </div>

    @if (service?.task?.type === TaskType.TYPE_CHANGE) {
      <form [formGroup]="service.form" class="mb-4">
        <div class="task-basic-panel">
          <div class="new-select-label">{{ 'Projects.changeTypeLabel' | translate }}</div>
          <ng-select
            ngSelectExtension
            class="w-100 new-select"
            [items]="changeTypes"
            [placeholder]="'Projects.changeTypePlaceholder' | translate"
            [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
            [tabIndex]="-1"
            bindLabel="name"
            bindValue="id"
            [searchable]="false"
            [formControlName]="service.TASK_SIDENAV_FORM.changeType"
          />
        </div>
      </form>
    }

    <div class="task-basic-panel d-flex flex-column mb-4">
      <div class="d-flex flex-row align-items-center">
        <div *ngIf="!service.isConfigChange" class="mr-1">
          <task-checkbox
            *ngIf="taskPermission?.edit"
            [task]="service?.task"
            [disableSubtasksPopover]="isProcessTaskContext"
            [placement]="'bottom'"
            (onCheckSubtasks)="checkedSubtasks($event)"
            (onUpdateTask)="updateTaskFromCheckbox($event)"
            #taskCheckboxComponent
          />
        </div>
        <div class="task-basic-preview-data__title-column">
          @if (editingTitle) {
            <div class="task-basic-preview-data__inline-edit mb-2">
              <input-v2
                [formControl]="titleEditControl"
                [placeholder]="titlePlaceholderKey | translate"
                (onKeydown)="onEnter($event)"
              />
            </div>
          } @else {
            <div
              class="task-name"
              [class.task-name--editable]="allowInlineEditing"
              (click)="startTitleEdit()"
            >
              {{ service?.task?.description }}
            </div>
          }
          <div
            *ngIf="shouldShowProjectInfo"
            class="pointer"
            (click)="navigateToProject(service?.task?.project)"
          >
            <span *ngIf="assignedDisplayName" class="client-name"> {{ assignedDisplayName }}&nbsp; </span>
            <span class="address">
              {{ service?.task?.project?.fullNameAndAddress }},
              {{ service?.task?.project?.nameAndProjectID }}</span
            >
          </div>
        </div>
      </div>

      @if (editingDescription) {
        <div class="task-basic-preview-data__description-editor">
          <quill-editor
            [formControl]="contentEditControl"
            class="quill-v2"
            [placeholder]="'Projects.enterDescription-task' | translate"
          />
        </div>
      } @else if (shouldShowInlineDescriptionPlaceholder) {
        <div class="description description--placeholder pointer" (click)="startDescriptionEdit()">
          <span>{{ 'Projects.enterDescription-task' | translate }}</span>
          @if (allowInlineEditing) {
            <img draggable="false" src="/assets/img/pencil-icon.svg" alt="Edit" />
          }
        </div>
      } @else if (shouldShowDescriptionValue) {
        <div
          class="description description--editable"
          [class.pointer]="allowInlineEditing"
          (click)="startDescriptionEdit()"
        >
          <div class="value ql-editor" [innerHTML]="service.safeContent"></div>
        </div>
      }
    </div>

    @if (!isProcessTaskContext) {
      <form [formGroup]="service.form" class="mb-4">
        <div class="task-basic-panel task-basic-preview-data__meta-panel">
          <div>
            <div class="new-select-label">{{ 'Projects.projectName' | translate }}</div>
            <project-selection
              class="w-100"
              [disabled]="!!service.task?.parent || !!service.connectedTask || !!service?.task?.isDeleted"
              [isFieldRequired]="!!service.isConfigChange || isProjectRequired"
              [requiredid]="service.projectID"
              [form]="service.form"
              [addTag]="canProjectAdd"
              [controlName]="service.TASK_SIDENAV_FORM.projectId"
              (onProjectClear)="resetProjectControl()"
            />
          </div>

          <div *ngIf="service?.task?.type !== TaskType.TYPE_CHANGE">
            <div class="new-select-label">{{ 'Projects.taskGroupLabel' | translate }}</div>
            <ng-select
              ngSelectExtension
              class="w-100 new-select"
              [items]="taskGroups$ | async"
              [placeholder]="'Projects.chooseTaskGroup' | translate"
              [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
              [tabIndex]="-1"
              bindLabel="name"
              bindValue="id"
              [searchable]="false"
              [formControlName]="service.TASK_SIDENAV_FORM.groupId"
            />
          </div>
        </div>
      </form>
    }
  </div>

  <ng-container *ngIf="!!service.connectedTask && service.isPreview">
    <div class="d-flex justify-content-between align-items-center task-basic-preview-data__connected-task">
      <span>{{ service.connectedTask.description }}</span>
      <svg-icon
        class="cursor-pointer"
        (click)="
          service.permissionCtrl.linkedPreview ? taskManager.previewTask(service.task?.linkedChange) : null
        "
        [src]="'/assets/img/ic-external-link.svg'"
        [svgStyle]="{ width: '16px', height: '16px' }"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="service.isConfigChange && service.isPreview">
    <task-changes-summary />
  </ng-container>

  <div
    *ngIf="!!service.isConfigChange && !storage?.Employee?.isClient && service.safeContentInternalNote"
    class="mb-4"
  >
    <div class="new-select-label red">{{ 'Projects.internalNote' | translate }}</div>
    <div
      *ngIf="!!service.safeContentInternalNote"
      class="value ql-editor"
      [innerHTML]="service.safeContentInternalNote"
    ></div>
  </div>

  <div class="mb-4">
    <task-sidenav-blue />
  </div>
</div>
